export const copyQRCodeImage = () => {
  const svgElement = document
    .getElementById('my_qrcode')
    ?.querySelector<SVGSVGElement>('svg')

  if (svgElement) {
    try {
      const svgData = new XMLSerializer().serializeToString(svgElement)
      const svgBlob = new Blob([svgData], {
        type: 'image/svg+xml;charset=utf-8',
      })

      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      const img = new Image()

      const svgUrl = URL.createObjectURL(svgBlob)

      img.onload = async () => {
        canvas.width = img.width
        canvas.height = img.height

        if (ctx) {
          ctx.drawImage(img, 0, 0)

          try {
            const blob = await new Promise<Blob>((resolve) => {
              canvas.toBlob((blob) => {
                if (blob) resolve(blob)
              }, 'image/png')
            })

            await navigator.clipboard.write([
              new ClipboardItem({
                'image/png': blob,
              }),
            ])
          } catch {
            const dataUrl = canvas.toDataURL()
            const textArea = document.createElement('textarea')
            textArea.value = dataUrl
            document.body.appendChild(textArea)
            textArea.select()
            document.execCommand('copy')
            document.body.removeChild(textArea)
          }
        }

        URL.revokeObjectURL(svgUrl)
      }

      img.src = svgUrl
    } catch (error) {
      // Silently handle error
    }
  }
}
